import { createBrowserRouter } from "react-router-dom";
import Layout from "./Layout";
import Home from "../Page/Home/Home";
import NewsDetls from "../Page/NewsFid/NewsDetls";
import Tv from "../Page/Tv/Tv";
import RecordingVideos from "../Page/RecordingVideos/RecordingVideos";
import Connection from "../Page/Connection/Connection";
import Activity from "../Page/Activity/Activity";
import Join from "../Page/Join/Join";
import Opportunities from "../Page/Opportunities/Opportunities";
import Policy from "../Page/Policy/Policy";
import Prabhupada from "../Page/Prabhupada/Prabhupada";
import Prasadam from "../Page/Prasadam/Prasadam";
import Residence from "../Page/Residence/Residence";
import AllTemples from "../Page/Temple/AllTemples";
import NewTemple from "../Page/Temple/NewTemple";
import MayapurTmple from "../Page/Temple/MayapurTmple";
import MayapurTemple from "../Page/Temple/MayapurTmple";
import PrivetPolicy from "../Page/Policy/PrivetPlolicy";
import DashboardLayout from "./DashboardLayout";
import DashboardHome from "../Dashboard/DashboardHome/DashboardHome";
import NewNewsFront from "../Page/NewsFid/New/NewNewsFront";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/news", element: <NewNewsFront /> },
      {
        path: "/newsDetails/:id",
        element: <NewsDetls />,
      },
      { path: "/tv", element: <Tv /> },
      { path: "/Connection", element: <Connection /> },
      { path: "/Activity", element: <Activity /> },
      { path: "/Join", element: <Join /> },
      { path: "/Opportunities", element: <Opportunities /> },
      { path: "/GeneralPolicy", element: <Policy /> },
      { path: "/PrivetPolicy", element: <PrivetPolicy /> },
      { path: "/Prabhupada", element: <Prabhupada /> },
      { path: "/Prasadam", element: <Prasadam /> },
      { path: "/Residence", element: <Residence /> },
      { path: "/AllTemples", element: <AllTemples /> },
      { path: "/NewTemple", element: <NewTemple /> },
      { path: "/MayapurTemple", element: <MayapurTemple /> },
      { path: "/RecordingVideos", element: <RecordingVideos /> },
    ],
  },
   {
    path: "/dashboard",
    element: (
      <DashboardLayout />
    ),
    children: [
      {
        index: true,
        element: (
          <DashboardHome />
        ),
      },
      {
        path: "news-post",
        element: (
          <DashboardHome />
        ),
      },
  
    ],
  },
  
]);
export default router;